import { compact } from 'lodash'

export function compactMap(array, callback) {
  return compact(array.map(callback))
}
